import Api from '@/api/index'

const Approval = {
  namespaced: true,
  state: {
    all_approval_groups: [],
    one_approval_group: {
      name: "Nova Aprovação",
      how_many_must_approve: "all_approve",
      form_ids: [],
      company_id: null,
      solution_id: null,
      created_at: null,
      updated_at: null,
      approvals: []
    },

    default_approval_group: {
      name: "Nova Aprovação",
      how_many_must_approve: "all_approve",
      form_ids: [],
      company_id: null,
      solution_id: null,
      created_at: null,
      updated_at: null,
      approvals: []
    },

    all_approvals: [],
    one_approval: null
  },

  getters: {
    
  },

  mutations: {
    clearOneApproval(state) {
      state.one_approval_group = {...state.default_approval_group}
    },
    setAllApprovalGroups(state, approval_groups) {
      state.all_approval_groups = [...approval_groups];
    },
    setAllApprovals(state, approvals) {
      state.all_approvals = [...approvals];
    },
    setFormIds(state, forms) {
      state.one_approval_group.form_ids = forms.map((form) => form.id);
    },
    setOneApprovalGroup(state, approval_group) {
      state.one_approval_group = {
        ...state.one_approval_group,
        ...approval_group
      }
    },
    removeFromAllApprovalGroups(state, approval_deleted) {
      const idx = state.all_approval_groups.findIndex((ag) => ag.id === approval_deleted.id);
      state.all_approval_groups.splice(idx, 1);
    },
    removeFormFromApprovalGroup(state, form_id) {
      const idx = state.one_approval_group.form_ids.findIndex((id) => id === form_id);
      state.one_approval_group.form_ids.splice(idx, 1);
    }
  },

  actions: {
    clearOneApprovalGroup({commit}) {
      commit("clearOneApproval");
    },
    async index({commit, dispatch}) {
      try {
        const response = await Api.Approval.index();
        const approvals = response.data;
        commit("setAllApprovals", approvals);
      } catch (error) {
        const notification = {
          msg: `Erro: ${error}`,
          type: "error"
        }
        dispatch("Notification/add", notification, {root: true});
        console.log(error);
      }
    },
    indexApprovalGroups({commit, dispatch}, filter) {
      // console.log("entrou")
      return Api.Approval.indexApprovalGroups(filter).then((r) => r.data).then((data) => {
        const approval_groups = data.data.map((approval_group) => approval_group.attributes)
        commit("setAllApprovalGroups", approval_groups);
        return data;
      }).catch((error) => {
        const notification = {
          msg: `Erro: ${error}`,
          type: "error"
        };
        dispatch("Notification/add", notification, {root: true});
      })
    },
    createApprovalGroup({commit, dispatch, state}) {
      let notification = {};

      return Api.Approval.createApprovalGroup(state.one_approval_group).then((r) => r.data).then((approval_group) => {
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return approval_group;
      }).catch((error) => {
        console.log("error => ", error)
        notification.type = "error";
        notification.error = `Erro: ${error}`;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true})
      })
    },
    showApprovalGroup({commit, dispatch}, approval_group_id) {
      return Api.Approval.showApprovalGroup(approval_group_id).then((r) => r.data.data.attributes).then((approval_group) => {
        // console.log("asd => ", approval_group)
        commit("setOneApprovalGroup", approval_group);
        return approval_group;
      }).catch((error) => {
        let notification = {};
        notification.type = "error";
        notification.msg = `Erro: ${error}`;
        dispatch("Notification/add", notification, {root: true});
      })
    },
    updateApprovalGroup({commit, dispatch, state}) {
      let notification = {};
      
      return Api.Approval.updateApprovalGroup(state.one_approval_group).then((r) => r.data).then((approval_group) => {
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return approval_group;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = `Erro: ${error}`;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },
    deleteApprovalGroup({commit, dispatch}, approval_group_id) {
      let notification = {};
      
      Api.Approval.deleteApprovalGroup(approval_group_id).then((r) => r.data).then((approval_deleted) => {
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        commit("removeFromAllApprovalGroups", approval_deleted);
      }).catch((error) => {
        notification.type = "error";
        notification.msg = `Erro: ${error}`;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },

    // DoneApprovals

    createDoneApproval({dispatch}, done_approval) {
      let notification = {};

      return Api.DoneApproval.create(done_approval).then((r) => r.data).then((approval_config) => {
        notification.type = "success";
        notification.msg = "Feito com sucesso";
        return done_approval;
      }).catch((error) => {
        notification.type = "error";
        notification.msg = `Erro: ${error.response.data.message}`;
      }).finally(() => {
        dispatch("Notification/add", notification, {root: true});
      })
    },
  }

};

export default Approval;